module.exports = __webpack_public_path__ + "img/glass-pilsner.8aadc931.svg";